// Pure logic for the Media Gallery: constants and upload validation. No
// React/I/O so it is unit-tested and portable. These checks are only for a
// better UX — the server re-validates the file's real content, type, size,
// permission and journey itself (and never uses the user's filename). Filtering,
// counting and paging are done by the server, not here.

export const MEDIA_PAGE_SIZE = 12;
export const MEDIA_CAPTION_MAX = 120;
export const MAX_IMAGE_BYTES = 10 * 1024 * 1024;
export const MAX_VIDEO_BYTES = 200 * 1024 * 1024;

// The types the server accepts (it checks the bytes, not just this).
const IMAGE_TYPES = ["image/jpeg", "image/png", "image/gif", "image/webp"];
const VIDEO_TYPES = ["video/mp4", "video/quicktime", "video/webm"];
export const ACCEPTED_FILE_TYPES = [...IMAGE_TYPES, ...VIDEO_TYPES].join(",");

export const MEDIA_TYPE_TABS = ["All", "Photos", "Videos"];
export const TAB_TO_TYPE = { All: "", Photos: "IMAGE", Videos: "VIDEO" };
export const TAB_TO_COUNT = { All: "all", Photos: "images", Videos: "videos" };

export const isVideo = (item) => item.media_type === "VIDEO";

// "IMAGE" | "VIDEO" | null (not an accepted type).
export function mediaTypeOfFile(file) {
  if (!file || typeof file.type !== "string") return null;
  if (IMAGE_TYPES.includes(file.type)) return "IMAGE";
  if (VIDEO_TYPES.includes(file.type)) return "VIDEO";
  return null;
}

export function formatFileSize(bytes) {
  if (bytes >= 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${Math.max(1, Math.round(bytes / 1024))} KB`;
}

// values: { caption, journeyId, cityVisitId }
export function validateMediaUpload(values, file) {
  const errors = {};
  const type = mediaTypeOfFile(file);

  if (!file) errors.file = "Choose an image or video to upload.";
  else if (!type) errors.file = "Only JPEG, PNG, GIF or WebP images and MP4, MOV or WebM videos can be uploaded.";
  else if (type === "IMAGE" && file.size > MAX_IMAGE_BYTES) errors.file = "Images must be 10 MB or smaller.";
  else if (type === "VIDEO" && file.size > MAX_VIDEO_BYTES) errors.file = "Videos must be 200 MB or smaller.";

  const caption = values.caption.trim();
  if (!caption) errors.caption = "Add a caption.";
  else if (caption.length > MEDIA_CAPTION_MAX) errors.caption = `Caption must be ${MEDIA_CAPTION_MAX} characters or fewer.`;

  if (!values.journeyId) errors.journeyId = "Select the journey this belongs to.";
  if (!values.cityVisitId) errors.cityVisitId = "Select the city visit.";
  return errors;
}

// The multipart body for POST /media/upload — only these fields, never form state spread in.
export function buildUploadForm(values, file) {
  const form = new FormData();
  form.append("journey_id", String(values.journeyId));
  form.append("city_visit_id", String(values.cityVisitId));
  form.append("caption", values.caption.trim());
  form.append("file", file);
  return form;
}
